<template>
  <div class="FundoArgolas" :style="CoresArgolas">
      <div class="anel1"></div>
      <div class="anel2"></div>
      <div class="anel3"></div>
  </div>
</template>

<script>
export default {
    name: "ArgolasEffect",
		data() {
			return {
                backgroundArgolas: "#000",
                CorArgola: "#008fac"
            };
		},
	components: {},
    props: ["configArgolas"],
	computed: {
		CoresArgolas: function () {
			return [
                {"--argolas-background-color": this.backgroundArgolas},
                {"--argolas-color": this.CorArgola}
            ];
		}
    },
    methods: {
        setConfiguracaoInicial() {
            if(this.configArgolas) {
                if (this.configArgolas.backgroundArgolas) {
					this.backgroundArgolas = this.configArgolas.backgroundArgolas;
				}
				if (this.configArgolas.CorArgola) {
					this.CorArgola = this.configArgolas.CorArgola
				}
            }
        }
    },
    created() {
            this.setConfiguracaoInicial();
    }
};
</script>

<style>
.FundoArgolas {
    position: relative;
    width: 100%;
    height: 100%;
    background: var(--argolas-background-color);
    margin: auto;
}

.anel1 {
    position: absolute;
    top: 10%;
    left: 10%;
    width: 80%;
    height: 15%;
    border: solid 2px var(--argolas-color);
    border-radius: 10px;
}

.anel2 {
    position: absolute;
    top: 40%;
    left: 10%;
    width: 80%;
    height: 15%;
    border: solid 2px var(--argolas-color);
    border-radius: 10px;
}

.anel3 {
    position: absolute;
    top: 70%;
    left: 10%;
    width: 80%;
    height: 15%;
    border: solid 2px var(--argolas-color);
    border-radius: 10px;
}
</style>